/**
 * One date format across BR OS: DD-MM-YYYY (Fan, 2026-10-10).
 * Date + time: DD-MM-YYYY HH:MM (24h). Use these for every displayed date.
 */

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

const pad = (n) => String(n).padStart(2, "0");

function toDate(value) {
  if (value === null || value === undefined || value === "") return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

/** "09-10-2026". Date-only strings ("2026-10-09") are never shifted by time zone. */
export function formatDMY(value, fallback = "—") {
  if (typeof value === "string") {
    const m = value.trim().match(DATE_ONLY_RE);
    if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  }
  const d = toDate(value);
  if (!d) return typeof value === "string" && value ? value : fallback;
  return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
}

/** "09-10-2026 14:05". Date-only strings return just the date. */
export function formatDMYTime(value, fallback = "—") {
  if (typeof value === "string" && DATE_ONLY_RE.test(value.trim())) return formatDMY(value, fallback);
  const d = toDate(value);
  if (!d) return typeof value === "string" && value ? value : fallback;
  return `${formatDMY(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** "09-10-2026 → 16-10-2026" */
export function formatDMYRange(start, end, fallback = "—") {
  return `${formatDMY(start, fallback)} → ${formatDMY(end, fallback)}`;
}
